"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorByCoordinates = getColorByCoordinates;

var _toColor = require("../toColor");

/**
 * Converts coordinates to `Color`.
 * @param h Hue.
 * @param x X-coordinate.
 * @param y Y-coordinate.
 * @param width The width of the canvas.
 * @param height The height of the canvas.
 * @see [WHAT IS "COLOR"?](https://github.com/Wondermarin/react-color-palette#color)
 */
function getColorByCoordinates(h, x, y, width, height) {
  var s = x / width * 100;
  var b = y / height * 100;
  return (0, _toColor.toColor)("hsb", {
    h: h,
    s: s,
    b: 100 - b
  });
}